module.exports = __webpack_public_path__ + "static/media/happy-emoji-svgrepo-com.d8c033d2.svg";